<template>
  <base-section id="theme-features">
    <base-section-heading title="Wear Hue Features" />

    <v-container>
      <v-row>
        <v-col
          v-for="(feature, i) in features"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="feature"
            align="left"
            horizontal
          >
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Veritatis
            illum veniam cum dolores ratione commodi beatae quas maxime,
            laboriosam excepturi solut!
          </base-avatar-card>
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionThemeFeatures',

    data: () => ({
      features: [
        {
          title: 'Link your Philips Hue Bridge',
          icon: 'mdi-pencil-box-outline',
        },
        {
          title: 'View all of your devices',
          icon: 'mdi-fountain-pen-tip',
        },
        {
          title: 'Toggle device state',
          icon: 'mdi-bluetooth-audio',
          color: 'primary',
          dark: true,
        },
        {
          title: 'Set colors + brightness',
          icon: 'mdi-cellphone',
        },
      ],
    }),
  }
</script>
